"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FullscreenButton = void 0;
var _icons = require("@ori-ui/icons");
var _useIPaperFullscreen = require("../../hooks/useIPaperFullscreen");
var _useTranslations = require("../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FullscreenButton = ()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { isFullscreen, toggle } = (0, _useIPaperFullscreen.useIPaperFullscreen)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.IconButton, {
        "aria-pressed": isFullscreen,
        "aria-label": isFullscreen ? translations.exitFullscreen : translations.enterFullscreen,
        title: isFullscreen ? translations.exitFullscreen : translations.enterFullscreen,
        variant: "contained",
        color: "default",
        size: "large",
        onClick: toggle,
        children: [
            isFullscreen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Reduce, {
                fontSize: "inherit"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Enlarge, {
                fontSize: "inherit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FullscreenGlobalStyles, {
                isFullscreen: isFullscreen
            })
        ]
    });
};
exports.FullscreenButton = FullscreenButton;
